import { HTTP } from '../../utils'

export const getTransferArticulationMappings = (page, count, keyword) => {
  let url = 'transferArticulation/list?page=' + page + '&count=' + count
  if (keyword) {
    url += '&term=' + keyword
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteAllTransferArticulationMappings = () => {
  return HTTP().delete('transferArticulation/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForTransferArticulationMapping = (fileData) => {
  if (!fileData) {
    return
  }
  let url = 'transferArticulation/upload/'
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getSelfReportedProgramCountInfo = () => {
  return HTTP().get('selfReportedCourse/programCountInfo')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getSelfReportedCourseList = (keyword) => {
  let url = 'selfReportedCourse/list'
  if (keyword) {
    url += '?title=' + keyword
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getProgramCourseList = (streamId) => {
  let url = 'pathwaydata/stream/' + streamId + '/courses'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getProgramEducation = (streamId) => {
  let url = 'pathwaydata/stream/' + streamId + '/courses?type=EDUCATION'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getProgramCocurricular = (streamId) => {
  let url = 'pathwaydata/stream/' + streamId + '/courses?type=COCURRICULAR'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getRelatedPrograms = (programId) => {
  let url = 'pathwaydata/program/' + programId + '/related'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const setProgramCourseStatus = (data) => {
  let url = 'pathwaydata/catalog/' + data.uuid + '/status/' + data.status
  return HTTP().put(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getProgramCourseProgress = (courseId) => {
  return HTTP().get('competency/' + courseId + '/mcSummary')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const redirectUserToCourseDashboard = (data) => {
  return HTTP().get('user/navigateToCourseDashboard/' + data.courseId + '?token=' + data.token)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCatalogsForInstitution = (openId) => {
  return HTTP().get('catalog/getCatalogsByOpenId/' + openId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getSelfReportedCourse = (uuid) => {
  return HTTP().get('selfReportedCourse/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const addSelfReportedCourse = (data) => {
  let url = 'selfReportedCourse'
  if (data.uuid) {
    url += '/' + data.uuid
  }
  return HTTP().put(url, data)
  .then(res => {
    return res
  })
  .catch(e => {
    return e.response
  })
}

export const deleteMultipleSelfReportedCourses = (uuids) => {
  return HTTP().delete('selfReportedCourse/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/transfer/api.js